export default __webpack_public_path__ + "static/media/Any-device_small.3a657216.jpg";